import React, {useEffect, useMemo} from 'react';
import {Route, Switch, useParams} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import CompaniesEmployees from '../CompaniesEmployees';
import CompaniesHome from '../CompaniesHome';
import CompaniesCustomers from '../CompaniesCustomers';
import CompaniesDocuments from '../CompaniesDocuments';
import CompaniesNotification from '../CompaniesNotification';
import CompaniesEditing from '../CompaniesEditing';
import Menu from '../../Components/Menu';
import {ReactComponent as CompaniesIcon1} from '../../../assets/images/Components/Menu/companies1.svg';
import {ReactComponent as CompaniesIcon2} from '../../../assets/images/Components/Menu/companies2.svg';
import {ReactComponent as CompaniesIcon3} from '../../../assets/images/Components/Menu/companies3.svg';
import {ReactComponent as CompaniesIcon4} from '../../../assets/images/Components/Menu/companies4.svg';
import {ReactComponent as CompaniesIcon5} from '../../../assets/images/Components/Menu/companies5.svg';
import {getCompany, resetCompany} from '../../../redux/actions/company/companyActions';
import {useDispatch, useSelector} from 'react-redux';
import LoadPanel from '../../Components/LoadPanel';
import {useTranslation} from 'react-i18next';
import {clearEmployee} from '../../../redux/actions/employee/employeeActions';
import {clearClients} from '../../../redux/actions/clients/clientsActions';
import {resetAllDocuments} from '../../../redux/actions/documents/documentsActions';
import CompaniesCustomersSingle from '../CompaniesCustomers/CompaniesCustomersSingle';
import CustomerAdd from '../../Components/Companies/CustomerAdd';
import EmployeesAdd from '../../Components/Companies/EmployeesAdd';
import CompaniesEmployeesSingle from '../CompaniesEmployees/CompaniesEmployeesSingle';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';

const CompaniesInner = ({
                            isInnerVisible,
                            isMenuVisible,
                            handleNavLinkClick,
                            toggleYourContent,
                            isYourContentVisible
                        }) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {singleCompany, singleCompanyLoading} = useSelector((state) => state.company);
    const {profileMe} = useSelector((state) => state.profile);

    const permissionViewCustomers = hasPermission(PERMISSIONS.CUSTOMER_LIST, profileMe?.permissions ?? []);
    const permissionCompanyEdit = hasPermission(PERMISSIONS.COMPANY_EDIT, profileMe?.permissions ?? []);

    const {id} = useParams();

    const menuList = useMemo(() => {
        return [
            {
                name: t('CompaniesInner.employees'),
                icon: <CompaniesIcon1/>,
                count: singleCompany?.statistic?.employees ?? null,
                link: mainPath.companiesEmployees.replace(':id', id)
            },
            ...(permissionViewCustomers
                ? [
                    {
                        name: t('CompaniesInner.customers'),
                        icon: <CompaniesIcon2/>,
                        count: singleCompany?.statistic?.clients ?? null,
                        link: mainPath.companiesCustomers.replace(':id', id)
                    }
                ]
                : []),
            {
                name: t('CompaniesInner.documents'),
                icon: <CompaniesIcon3/>,
                count: singleCompany?.statistic?.documents ?? null,
                link: mainPath.companiesDocuments.replace(':id', id)
            },
            {
                name: t('CompaniesInner.notifications'),
                icon: <CompaniesIcon4/>,
                link: mainPath.companiesNotification.replace(':id', id)
            },
            ...(permissionCompanyEdit
                ? [
                    {
                        name: t('CompaniesInner.editing'),
                        icon: <CompaniesIcon5/>,
                        link: mainPath.companiesEditing.replace(':id', id)
                    }
                ]
                : [])
        ];
    }, [id, t, singleCompany]);
    const {projectsLoading} = useSelector((state) => state.projects);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    const fetchFunc = async () => {
      await dispatch(getCompany(id,signal));
    };
    fetchFunc();

    return () => {
      controller.abort();
      dispatch(resetCompany());
      dispatch(clearEmployee());
      dispatch(clearClients());
      dispatch(resetAllDocuments());
    };
  }, [id]);

    return (
        <>
            {isMenuVisible && (
                <Menu
                    title={t('CompaniesInner.companyMenu')}
                    back={t('CompaniesInner.yourCompanies')}
                    menuList={menuList}
                    toggleYourContent={toggleYourContent}
                    handleNavLinkClick={handleNavLinkClick}
                    isYourContentVisible={isYourContentVisible}
                    disabled={singleCompanyLoading || projectsLoading}
                />
            )}

            {singleCompanyLoading || projectsLoading ? (
                <div className={'companies-page-loader companies-page-loader-main'}>
                    <LoadPanel noBg={true} circleSize={50} staticPos={true}/>
                </div>
            ) : (
                <>
                    {isInnerVisible && (
                        <>
                            <Switch>
                                <Route path={mainPath.companiesCustomersAdd} component={CustomerAdd}/>
                                <Route path={mainPath.companiesEmployeesAdd} component={EmployeesAdd}/>
                                <Route path={mainPath.companiesCustomersSingle} component={CompaniesCustomersSingle}/>
                                <Route path={mainPath.companiesEmployeesSingle} component={CompaniesEmployeesSingle}/>
                                <Route path={mainPath.companiesEmployees} component={CompaniesEmployees}/>
                                <Route path={mainPath.companiesCustomers} component={CompaniesCustomers}/>
                                <Route path={mainPath.companiesDocuments} component={CompaniesDocuments}/>
                                <Route path={mainPath.companiesNotification} component={CompaniesNotification}/>
                                <Route path={mainPath.companiesEditing} component={CompaniesEditing}/>
                                <Route path={mainPath.company} component={CompaniesHome}/>
                            </Switch>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default CompaniesInner;
